<template>
  <div class="mt-2">
    <div v-if="loading">
      <v-skeleton-loader
        class="mx-auto"
        type="list-item, list-item-three-line, list-item-three-line, list-item-three-line,list-item,  list-item-three-line"
      ></v-skeleton-loader>
    </div>

    <div v-else-if="data">
      <v-list dense shaped color="transparent">
        <v-list-item-group
          color="primary"
          dense
          class="mb-4"
          v-model="selected"
        >
          <v-list-item
            dense
            v-for="(catObj, catslug) in data"
            :key="catslug"
            :value="catslug"
            @click="setDetail(catslug)"
          >
            <v-list-item-content dense>
              <v-list-item-title dense>{{
                catObj.title.toUpperCase()
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>
    <coding-see-also currentKey="coding-clinical-examples"></coding-see-also>
  </div>
</template>

<script>
// import ConditionsCategories from "@/assets/js/conditions/ConditionsCategories";
import ApiServices from "@/services/ApiServices";
import CodingSeeAlso from "@/components/icdStuff/CodingSeeAlso.vue";

export default {
  name: "CodingExampleMenuBtns",
  components: { CodingSeeAlso },
  mixins: [],

  props: {},
  data: function () {
    return {
      loading: false,
      data: null,
      selected: null,
    };
  },
  methods: {
    callApi() {
      this.loading = true;
      ApiServices.genericApiCall("/billing/clinicalCases/menuOptions")
        .then((response) => {
          this.data = response.data.menus;
        })
        .catch((error) => {
          console.log("error", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setDetail(detail) {
      this.$store.dispatch("setModeAndDetail", {
        mode: null,
        detail: detail,
      });
    },
    setSelected(detail) {
      this.selected = detail;
    },
  },
  computed: {
    storedItem: function () {
      return this.$store.state.detail;
    },
  },
  watch: {
    storedItem(val) {
      this.setSelected(val);
    },
  },
  mounted() {
    if (this.storedItem) this.setSelected(this.storedItem);
    this.callApi();
  },
};
</script>

<style scoped></style>
